'use strict';

const modal = [
  '$rootScope',
  '$state',
  '$window',
  '$q',
  '$http',
  '$templateCache',
  '$compile',
  '$controller',
  '$timeout',
  'resolveTemplate',
  'keyCodes',
  'scrollbarWidth',
  'slideshow',
  'bodyScroll',

  function ($rootScope, $state, $window, $q, $http, $templateCache, $compile, $controller, $timeout, resolveTemplate, keyCodes, scrollbarWidth, slideshow, bodyScroll) {
    var documentEl = angular.element($window.document);
    var bodyEl = angular.element($window.document.body);
    var wrapperEl = angular.element($window.document.querySelector('.Wrapper'));
    var footerEl;
    var notificationEl;
    var navEl;
    $timeout(() => {
      footerEl = angular.element($window.document.querySelector('.Footer-content'));
      navEl = angular.element($window.document.querySelector('.Navigation'));
    });

    var modals = [];
    var isListeningToKeyboardEvents = false;
    var service;

    /**
     * Compiles and shows modal window
     *
     * @param {String} content
     * @param {Object} options
     * @returns {angular.element}
     */
    function showModalWindow(content, options) {
      var modalWindowEl = angular.element('<sa-modal></sa-modal>');
      var modalScope = options.scope || $rootScope.$new();
      var controllerLocals;
      var scrollWidth;

      if (options.cssClass) {
        modalWindowEl.addClass(options.cssClass);
      }

      if (!options.preventCloseWithESC) {
        // Start listening to keyboard events
        if (!isListeningToKeyboardEvents) {
          documentEl.on('keyup', keyupHandler);
          isListeningToKeyboardEvents = true;
        }
      }

      if (options.controller) {
        controllerLocals = {
          $scope: modalScope
        };

        $controller(options.controller, controllerLocals);
      }

      modalScope.modalOptions = {
        closeOnBackgroundClick: options.closeOnBackgroundClick
      };

      if (modals.length === 1 && !slideshow.isVisible) {
        scrollWidth = scrollbarWidth();
        // TODO: refactor silly padding
        wrapperEl.css('padding_right', scrollWidth + 'px');
        bodyEl.css('padding_right', scrollWidth + 'px');
        if (!footerEl) {
          footerEl = angular.element($window.document.querySelector('.Footer-content'));
        }
        if (footerEl) {
          footerEl.css('padding_right', scrollWidth + 'px');
        }
        navEl.css('padding_right', scrollWidth + 'px');
        notificationEl = angular.element($window.document.querySelector('.Notification'));
        notificationEl.css('padding_right', scrollWidth + 'px');
      }

      modalScope.title = options.title;

      modalWindowEl.html(content);
      bodyEl.append(modalWindowEl);

      modalWindowEl = $compile(modalWindowEl)(modalScope);

      return modalWindowEl;
    }

    /**
     * Closes active modal window when ESC key is pressed.
     */
    function keyupHandler(event) {
      if (event.which === keyCodes.ESC) {
        service.dismiss();
      }
    }

    /**
     * Removes modal window from DOM, destroys modal instance.
     */
    function destroyModalWindow(modalWindow) {
      let destroyModal = () => {
        modalWindow.addClass('is-closed');
        modalWindow.remove();
      };

      bodyScroll.enable();
      if (!modals.length && !slideshow.isVisible) {
        // TODO: refactor silly padding
        bodyEl.css('padding_right', 0);
        wrapperEl.css('padding_right', 0);
        footerEl.css('padding_right', 0);
        navEl.css('padding_right', 0);
        notificationEl = angular.element($window.document.querySelector('.Notification'));
        notificationEl.css('padding_right', 0);
      }

      if (modalWindow) {
        modalWindow.addClass('is-closing');

        ['animationend', 'webkitAnimationEnd'].forEach((eventName) => {
          modalWindow.bind(eventName, destroyModal);
        });
      }
    }

    function createModalInstance() {
      var modalInstance = {
        resultDeferred: $q.defer(),
        resolveDeferred: $q.defer(),
        index: modals.length
      };

      modalInstance.result = modalInstance.resultDeferred.promise;
      modalInstance.resolve = modalInstance.resolveDeferred.promise;

      modals.push(modalInstance);

      return modalInstance;
    }

    service = {

      /**
       * Opens modal window.
       *
       * Options:
       * template - modal window template
       * templateUrl - modal window template url
       * windowClass - CSS class which will be added to modal window element
       * [closeOnStateChange=false] - whether modal window should close when state changes
       *
       * @param {Object} options
       * @returns {Object}
       */
      open: function (options) {
        var modalInstance;

        options = options || {};

        if (!(angular.isString(options.template) || angular.isString(options.templateUrl))) {
          throw new Error('`template` or `templateUrl` must be provided.');
        }

        modalInstance = createModalInstance();
        options.scope = options.scope || $rootScope.$new();
        options.scope.modalInstance = modalInstance;

        modalInstance.dismiss = function (reason) {
          if (options.dismissCallback) {
            options.dismissCallback(options.dismissCallbackOptions);
          }
          service.dismiss(reason, modalInstance);
        };

        modalInstance.close = function (reason) {
          service.close(reason, modalInstance);
        };

        modalInstance.destroy = function () {
          service.close(modalInstance);
        };

        modalInstance.closeOff = options.closeOff;

        if (options.closeOnStateChange) {
          $rootScope.$on('$stateChangeSuccess', function () {
            modalInstance.close();
          });
        }

        if (options.destroyOnStateChange) {
          $rootScope.$on('$stateChangeSuccess', function () {
            modalInstance.destroy();
          });
        }

        resolveTemplate(options.template || options.templateUrl).then(function (content) {
          modalInstance.modalWindow = showModalWindow(content, options);
          modalInstance.resolveDeferred.resolve();
        }, modalInstance.resolveDeferred.reject);

        return modalInstance;
      },

      /**
       * Close modal window without doing anything to promise.
       */
      destroy: function (modalInstance) {
        var index;

        modalInstance = modalInstance || modals[modals.length - 1];
        index = modals.indexOf(modalInstance);

        if (modalInstance) {
          modals.splice(index, 1);
          destroyModalWindow(modalInstance.modalWindow);
        }

        // Stop listening to keyboard events
        if (!modals.length) {
          documentEl.off('keyup', keyupHandler);
          isListeningToKeyboardEvents = false;
        }
      },

      /**
       * Close modal window and reject `result` promise with reason
       *
       * @param {*} reason
       */
      dismiss: function (reason, modalInstance) {
        var index;

        modalInstance = modalInstance || modals[modals.length - 1];
        index = modals.indexOf(modalInstance);

        if (modalInstance) {
          modals.splice(index, 1);
          modalInstance.resultDeferred.reject(reason);
          destroyModalWindow(modalInstance.modalWindow);
        }

        // Stop listening to keyboard events
        if (!modals.length) {
          documentEl.off('keyup', keyupHandler);
          isListeningToKeyboardEvents = false;
        }
      },

      /**
       * Close modal window and resolve `result` promise with reason
       *
       * @param {*} reason
       */
      close: function (reason, modalInstance) {
        var index;

        modalInstance = modalInstance || modals[modals.length - 1];
        index = modals.indexOf(modalInstance);

        if (modalInstance) {
          modals.splice(index, 1);
          modalInstance.resultDeferred.resolve(reason);
          destroyModalWindow(modalInstance.modalWindow);
        }

        // Stop listening to keyboard events
        if (!modals.length) {
          documentEl.off('keyup', keyupHandler);
          isListeningToKeyboardEvents = false;
        }
      }
    };

    return service;
  }
];

export default modal;



// WEBPACK FOOTER //
// ./app/src/services/modal.js